import { SERIAL_NUM_PREFIX } from '../constants';

export const isNullOrEmptyString = str => str === null || !str?.trim().length;
export const isNullOrEmptyOrZero = val =>
  val === null || !val?.trim().length || val?.toString() === '0';

export const encloseSerialModelNum = dataObj => {
  let enclosedData = '';
  if (dataObj?.model) {
    enclosedData = `(${dataObj?.model}`;
    enclosedData = dataObj?.serialNum
      ? `${enclosedData}, ${SERIAL_NUM_PREFIX}: ${dataObj?.serialNum})`
      : `${enclosedData})`;
  } else {
    enclosedData =
      dataObj?.serialNum && `(${SERIAL_NUM_PREFIX}: ${dataObj?.serialNum})`;
  }
  return enclosedData;
};

export const getSystemDescription = asset => {
  let systemDescription = '';
  if (asset?.systemDesc) {
    systemDescription = `${asset?.systemDesc}`;
    systemDescription = asset?.system
      ? `${systemDescription} (${asset?.system})`
      : `${systemDescription}`;
  } else {
    systemDescription = asset?.system && `(${asset?.system})`;
  }
  return systemDescription;
};

export const getSanitized = str =>
  str === 'null' || typeof str !== 'string'
    ? str
    : str.replace(/[^\w\s]/gi, '');

export const safeInputRegex = /^[\p{L}\p{N}\s.,!?_\-@#&%()]*$/u;

export const handleSafeInputChange = setter => event => {
  const { value } = event.target;
  if (safeInputRegex.test(value)) {
    setter(value);
  }
};

/* eslint-disable no-param-reassign */
export const isEncoded = uri => {
  uri = uri || '';
  return uri !== decodeURIComponent(uri);
};

export const fullyDecodeURI = uri => {
  while (isEncoded(uri)) {
    uri = decodeURIComponent(uri);
  }
  return uri;
};
/* eslint-enable no-param-reassign */

export const groupElements = (array, n) =>
  [...Array(Math.ceil(array?.length / n))].map((el, i) =>
    array.slice(i * n, (i + 1) * n),
  );

export const a11yProps = (index, panelId) => ({
  id: `${panelId}-tab-${index}`,
  'aria-controls': `${panelId}-tabpanel-${index}`,
});

export const truncateWords = (text, maxWords) => {
  const words = text.split(' ');

  if (words.length <= maxWords) {
    return text;
  }
  const truncatedText = words.slice(0, maxWords).join(' ');
  return `${truncatedText}...`;
};

export const localeLanguage = t => ({
  name: 'localeLanguage',
  months: [
    [t('January'), t('Jan')],
    [t('February'), t('Feb')],
    [t('March'), t('Mar')],
    [t('April'), t('Apr')],
    [t('May'), t('May')],
    [t('June'), t('Jun')],
    [t('July'), t('Jul')],
    [t('August'), t('Aug')],
    [t('September'), t('Sep')],
    [t('October'), t('Oct')],
    [t('November'), t('Nov')],
    [t('December'), t('Dec')],
  ],
  weekDays: [
    [t('Saturday'), t('Sat')],
    [t('Sunday'), t('Sun')],
    [t('Monday'), t('Mon')],
    [t('Tuesday'), t('Tue')],
    [t('Wednesday'), t('Wed')],
    [t('Thursday'), t('Thu')],
    [t('Friday'), t('Fri')],
  ],
  digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  meridiems: [
    [t('AM'), t('am')],
    [t('PM'), t('pm')],
  ],
});
